/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_account_register_error = /** @type {(inputs: {}) => string} */ () => {
	return `Při registraci došlo k chybě. Prosím zkuste znovu.`
};

const da_account_register_error = /** @type {(inputs: {}) => string} */ () => {
	return `Der opstod en fejl under registreringen. Prøv venligst igen.`
};

const de_account_register_error = /** @type {(inputs: {}) => string} */ () => {
	return `Bei der Registrierung ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.`
};

const en_account_register_error = /** @type {(inputs: {}) => string} */ () => {
	return `An error occurred while registering. Please try again.`
};

const es_account_register_error = /** @type {(inputs: {}) => string} */ () => {
	return `Se produjo un error durante el registro. Por favor, inténtalo de nuevo.`
};

const fr_account_register_error = /** @type {(inputs: {}) => string} */ () => {
	return `Une erreur s'est produite lors de l'inscription. Veuillez réessayer.`
};

const hu_account_register_error = /** @type {(inputs: {}) => string} */ () => {
	return `Hiba történt a regisztráció során. Kérjük, próbálkozz újra.`
};

const it_account_register_error = /** @type {(inputs: {}) => string} */ () => {
	return `Si è verificato un errore durante la registrazione. Riprova.`
};

const nl_account_register_error = /** @type {(inputs: {}) => string} */ () => {
	return `Er is een fout opgetreden bij het registreren. Probeer het opnieuw.`
};

const pl_account_register_error = /** @type {(inputs: {}) => string} */ () => {
	return `Wystąpił błąd podczas rejestracji. Spróbuj ponownie.`
};

const pt_account_register_error = /** @type {(inputs: {}) => string} */ () => {
	return `Ocorreu um erro no cadastro. Por favor, tente novamente.`
};

const sv_account_register_error = /** @type {(inputs: {}) => string} */ () => {
	return `Ett fel uppstod vid registreringen. Försök igen.`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const account_register_error = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.account_register_error(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("account_register_error", locale)
	if (locale === "cs") return cs_account_register_error(inputs)
	if (locale === "da") return da_account_register_error(inputs)
	if (locale === "de") return de_account_register_error(inputs)
	if (locale === "en") return en_account_register_error(inputs)
	if (locale === "es") return es_account_register_error(inputs)
	if (locale === "fr") return fr_account_register_error(inputs)
	if (locale === "hu") return hu_account_register_error(inputs)
	if (locale === "it") return it_account_register_error(inputs)
	if (locale === "nl") return nl_account_register_error(inputs)
	if (locale === "pl") return pl_account_register_error(inputs)
	if (locale === "pt") return pt_account_register_error(inputs)
	return sv_account_register_error(inputs)
};
export { account_register_error as "account.register_error" }